<div #contentDiv class="max-w-lg mx-auto flex-col pt-20 text-theme-text">
  <div class="flex-1 bg-theme-surface rounded-t-3xl min-h-[calc(100vh-5rem)] px-8 pt-16">
    <h2 class="text-2xl font-semibold text-theme-text mb-2">Tack för besöket!</h2>
    <p class="text-theme-text">Du är nu utloggad</p>
    <div class="mt-16">
      <app-page-button text="Startsida" icon="fa-home" (onClick)="goToStartPage()"></app-page-button>
    </div>
  </div>
</div>
